import React, { useState } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import ValidationFormControl from '../../styles/materialValidFormControl';

const PasswordInput = ({error, label, id, className, setPasswordRef}) => {
  const [values, setValues] = useState({
    password: '',
    showPassword: false,
  });

  const handleChange = (prop) => {
    return (event) => {
      setValues({...values, [prop]: event.target.value});
      if (setPasswordRef) {
        setPasswordRef(event.target.value);
      }
    };
  };

  const handleClickShowPassword = () => {
    setValues({...values, showPassword: !values.showPassword});
  };

  return (
    <ValidationFormControl error={error} className={className}>
      <InputLabel htmlFor="password">{label}</InputLabel>
      <Input
        id={id}
        type={values.showPassword ? 'text' : 'password'}
        value={values.password}
        onChange={handleChange('password')}
        required
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
            >
              {values.showPassword ? <span className="icon-light-eye"/> :
                <span className="icon-light-eye-slash"/>}
            </IconButton>
          </InputAdornment>
        }
      />
      {error && <FormHelperText id="component-error-text">{error}</FormHelperText>}
    </ValidationFormControl>
  );
};

export default PasswordInput;
